/**
 * Where the browser sends API calls.
 *
 * In development the API is a separate server, http://localhost:3000. In a
 * production build the site and the API are served from the same origin
 * (nginx in front of one Node process), so calls go to the page's own origin.
 *
 * A localhost VITE_API_URL is ignored in a production build. It can only be a
 * development .env copied to the server, and it is baked into the bundle: on a
 * visitor's machine it points at nothing, so every API call fails. On the
 * developer's own machine it quietly reaches their local API and database
 * instead, which looks like the live site working. That happened once.
 */
const configured = import.meta.env.VITE_API_URL as string | undefined;
const isLocal = (url: string) => /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(:\d+)?/i.test(url);

export const API_BASE: string = import.meta.env.PROD
  ? configured && !isLocal(configured) ? configured.replace(/\/$/, '') : ''
  : configured || 'http://localhost:3000';
